import { render, staticRenderFns } from "./CategoryHubFinder.vue?vue&type=template&id=a4ff5562&scoped=true"
import script from "./CategoryHubFinder.vue?vue&type=script&lang=js"
export * from "./CategoryHubFinder.vue?vue&type=script&lang=js"
import style0 from "./CategoryHubFinder.vue?vue&type=style&index=0&id=a4ff5562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ff5562",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LedSearchFormLicencePlate: require('/app/components/LedSearchFormLicencePlate.vue').default})
